import { render, staticRenderFns } from "./load-with-inventories.vue?vue&type=template&id=467e9d35&"
import script from "./load-with-inventories.vue?vue&type=script&lang=js&"
export * from "./load-with-inventories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports